<template>
  <div class="warp">
    <div class="downLoad">
      <!--      <div class="moreTable" v-show="tableDate.length > 1">-->
      <!--        <div class="title">缴费单位</div>-->
      <!--        <div :class="tabidx == index? 'header se ':'header'" v-for="(item,index) in tableDate" :key="item.index"-->
      <!--             @click="tab(index)">-->
      <!--          <img-->
      <!--              :src="tabidx == index?require('../../../assets/img/tablefirmoff.png'):require('../../../assets/img/tablefirmon.png')"-->
      <!--              alt=""> {{ item.enterpriseName }}-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="tableCon">
        <div class="content" id="pdfDom">
          <div class="tabheader">
            <span>收</span>
            <span>据</span>
            <span>单</span>
          </div>
          <div class="firm">
            <span>交款单位：{{ currentTable.tenantName }}</span>
            <span>交款日期：<div style="width: 240rem"></div></span>
          </div>
          <div class="details">
            <table border="1" width="100%" height="100%" cellspacing="0" cellpadding="0" align="center">
              <tr>
                <th rowspan="2">账目名称</th>
                <th rowspan="2">房间</th>
                <th rowspan="2">时间</th>
                <th rowspan="2">小计（元）</th>
                <th colspan="11">金 额</th>
                <th rowspan="2">备注</th>
              </tr>
              <tr>
                <th>亿</th>
                <th>千</th>
                <th>百</th>
                <th>十</th>
                <th>万</th>
                <th>千</th>
                <th>百</th>
                <th>十</th>
                <th>元</th>
                <th>角</th>
                <th>分</th>
              </tr>
              <tr>
                <td>电费缴费</td>
                <td>{{ currentTable.roomName }}</td>
                <td>{{ currentTable.completeTime }}</td>
                <td>{{ currentTable.amount }}</td>
                <td class="digit">{{ val1 }}</td>
                <td class="digit">{{ val2 }}</td>
                <td class="digit">{{ val3 }}</td>
                <td class="digit">{{ val4 }}</td>
                <td class="digit">{{ val5 }}</td>
                <td class="digit">{{ val6 }}</td>
                <td class="digit">{{ val7 }}</td>
                <td class="digit">{{ val8 }}</td>
                <!--                元-->
                <td class="digit">{{ val }}</td>
                <!--                角-->
                <td class="digit">{{ val10 }}</td>
                <td class="digit">{{ val11 }}</td>
                <td></td>
              </tr>
              <tr v-for="item in ['', '', '']">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td colspan="2">合计（大写）</td>
                <td colspan="14"></td>
              </tr>
            </table>
          </div>
          <div class="footer">
            <div class="men">收款人：</div>
            <div class="price">会 计：</div>
            <div class="compony">收款单位：{{ EnterpriseInfo.firmName }}</div>
          </div>
        </div>
      </div>
      <div class="operation">
        <el-button type="primary" @click="exportWord()">下载</el-button>
        <el-button type="danger" @click="$emit('hidden', false)">退出</el-button>
      </div>
    </div>
  </div>

</template>

<script>
import docxtemplater from 'docxtemplater'
import PizZip from 'pizzip'
import JSZipUtils from 'jszip-utils'
import {saveAs} from 'file-saver'
import {defaulturl} from '../../../../config'
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import html2pdf from 'html2pdf.js';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

// 注册字体，如果需要使用中文字体，请根据实际情况设置字体文件路径
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  props: ['tableDate'],
  data() {
    return {
      tabidx: 0,
      currentTable: {},
      val: [],
      val1: '',
      val2: '',
      val3: '',
      val4: '',
      val5: '',
      val6: '',
      val7: '',
      val8: '',
      val9: '',
      val10: '',
      val11: '',
    }
  },
  mounted() {
    if (this.tableDate) {
      this.tab(0)
    }
  },
  computed: {
    EnterpriseInfo() {
      return this.$store.state.project.EnterpriseInfo
    },
  },
  methods: {
    tab(idx) {
      this.tabidx = idx
      this.currentTable = this.tableDate[idx]
      this.handleCounts(this.tableDate[idx].amount)
      // console.log(this.tableDate[idx]);
    },

    counts(num1, num2) {
      let val = ''
      if (!num2 && !!num1 && num1 !== '￥') {
        val = '￥'
      } else if (num1 == '￥') {
        val = ''
      }
      return val
    },

    handleCounts(num) {
      // 假设金额为小数，单位为元
      // const amount = 12345.67;

      // 将金额转换为字符串
      const amountString = num.toString();

      // 将金额拆分为整数部分和小数部分
      const [integerPart, decimalPart] = amountString.split('.');

      // 获取整数部分的位数
      const integerPartDigitCount = integerPart.length;
      // console.log(integerPart, decimalPart, integerPartDigitCount)

      // 遍历每个位数，将数字放入相应的 div 盒子
      const digitElements = document.querySelectorAll('.digit');
      for (let i = digitElements.length - 1; i >= 0; i--) {
        const digitElement = digitElements[i];
        // console.log(digitElement)
        if (i === 10) {
          // 分
          this.val1 = parseInt(decimalPart.charAt(1));
          digitElement.textContent = this.val1.toString();
        } else if (i === 9) {
          // 角
          this.val2 = parseInt(decimalPart.charAt(0));
          digitElement.textContent = this.val2.toString();
        } else if (i === 8) {
          // 元
          this.val3 = integerPartDigitCount > 0 ? parseInt(integerPart.charAt(integerPartDigitCount - 1)) : 0;
          digitElement.textContent = this.val3.toString();
        } else if (i === 7) {
          // 十
          this.val4 = integerPartDigitCount > 1 ? parseInt(integerPart.charAt(integerPartDigitCount - 2)) : this.counts(this.val3, this.val4);
          digitElement.textContent = this.val4.toString();
        } else if (i === 6) {
          // 百
          this.val5 = integerPartDigitCount > 2 ? parseInt(integerPart.charAt(integerPartDigitCount - 3)) : this.counts(this.val4, this.val5);
          digitElement.textContent = this.val5.toString();
        } else if (i === 5) {
          // 千
          this.val6 = integerPartDigitCount > 3 ? parseInt(integerPart.charAt(integerPartDigitCount - 4)) : this.counts(this.val5, this.val6);
          digitElement.textContent = this.val6.toString();
        } else if (i === 4) {
          // 万
          this.val7 = integerPartDigitCount > 4 ? parseInt(integerPart.charAt(integerPartDigitCount - 5)) : this.counts(this.val6, this.val7);
          digitElement.textContent = this.val7.toString();
        } else if (i === 3) {
          // 十
          this.val8 = integerPartDigitCount > 5 ? parseInt(integerPart.charAt(integerPartDigitCount - 6)) : this.counts(this.val7, this.val8);
          digitElement.textContent = this.val8.toString();
        } else if (i === 2) {
          // 百
          this.val9 = integerPartDigitCount > 6 ? parseInt(integerPart.charAt(integerPartDigitCount - 7)) : this.counts(this.val8, this.val9);
          digitElement.textContent = this.val9.toString();
        } else if (i === 1) {
          // 千
          this.val10 = integerPartDigitCount > 7 ? parseInt(integerPart.charAt(integerPartDigitCount - 8)) : this.counts(this.val9, this.val10);
          digitElement.textContent = this.val10.toString();
        } else if (i === 0) {
          // 亿
          this.val11 = integerPartDigitCount > 8 ? parseInt(integerPart.slice(0, integerPartDigitCount - 8)) : this.counts(this.val10, this.val11);
          digitElement.textContent = this.val11.toString();
        }
      }
    },

    exportWord() {
      // 获取要转换为 PDF 的 HTML 元素
      const element = document.getElementById('pdfDom');
      // 使用 html2canvas 将 HTML 转换为 Canvas
      html2canvas(element)
          .then((canvas) => {
            // 创建新的 jsPDF 实例
            const pdf = new jsPDF('p', 'mm', 'a4');
            // 将 Canvas 转换为图像，并将其添加到 PDF 中
            pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 50, 210, 80);
            // 保存 PDF 文件
            pdf.save('收据单.pdf');
          });
    }
  }
}
</script>

<style scoped lang="less">
.warp {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.24);
  z-index: 999;

}

.downLoad {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 55vh;
  display: flex;

  .moreTable {
    width: 10vw;
    height: 100%;
    background-color: #fff;

    .title {
      height: 6.5vh;
      line-height: 6.5vh;
      padding-left: 1vw;
      font-size: 18rem;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
    }

    .header {
      width: 100%;
      height: 3.6vh;
      line-height: 3.6vh;
      background: #fff;
      font-size: 16rem;
      padding: 0 1vw;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: pointer;
    }

    .se {
      background: rgba(13, 148, 255, 0.07);
    }
  }

  .tableCon {
    width: 60vw;
    height: 100%;
    background-color: #DADCE0;
    position: relative;

    .control {
      width: 12%;
      height: 16vh;
      position: absolute;
      bottom: 6vh;
      left: 0;
      // background-color: #060;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: center;
    }

    .content {
      width: 90%;
      height: 77%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: #ffe1f0;
      border: 1px solid #999;
      padding: 25rem 30rem;

      .tabheader {
        font-size: 22rem;
        font-family: Source Han Serif CN;
        font-weight: bold;
        color: #333333;
        width: 380rem;
        padding: 0 10rem 0rem 10rem;
        margin: 0 0 10rem 100rem;
        border-bottom: 3px solid #444;
        display: flex;
        justify-content: space-between;
      }

      .firm {
        display: flex;
        justify-content: space-between;
      }

      .details {

        & > table {
          tr {
            height: 4vh;
            text-align: center;
          }

          .bigger {
            font-size: 24rem;
            font-family: Source Han Serif CN;
            font-weight: 500;
            color: #000000;
          }
        }
      }

      .footer {
        display: flex;
        padding: 10rem 20rem;

        .men {
          margin-right: 150rem;
        }

        .price {
          margin-right: 150rem;
        }
      }
    }
  }

  .operation {
    width: 8.3vw;
    height: 100%;
    background-color: #fff;
    padding: 16px 28px;

    & > button {
      display: block;
      margin-bottom: 56px;
      width: 100%;
      height: 40px;
      margin-left: 0;
    }

    & > button:nth-child(2) {
      background: #FD4238;
    }
  }
}
</style>